import {Button, Flex, Popconfirm} from 'antd';
import React from 'react';

import {ReactComponent as Delete} from '../../../assets/icons/deleteIcon.svg';
import {ReactComponent as Edit} from '../../../assets/icons/editIcon.svg';
import usePlatformStore from '../../../store/platformStore/platformStore';
import {shouldBlockFree} from '../../../utils/SubscriptionHelper';

const ActionsButton: React.FC<{
  record: any;
  setShowModel: React.Dispatch<React.SetStateAction<boolean>>;
  setEditData: React.Dispatch<any>;
  setIsEdit: React.Dispatch<React.SetStateAction<boolean>>;
  isConfigurator?: boolean;
  handleDelete?: (_id: string[] | string) => void;
  noEdit?: boolean;
  noDelete?: boolean;
}> = ({
  record,
  setShowModel,
  setEditData,
  setIsEdit,
  handleDelete,
  noEdit = false,
  noDelete = false,
  isConfigurator = false
}) => {
  return shouldBlockFree() ? (
    <Flex align="center" justify="flex-start" style={{width: 'fit-content'}}>
      {!noEdit && (
        <Button
          onClick={() => {
            usePlatformStore.getState().setOpenOnFreeTrialMessageModel(true);
          }}
          shape="circle"
          type="link"
          disabled={isConfigurator ? false : record.status === 'accepted'}
          style={{marginRight: '20px', backgroundColor: '#F5FBF3'}}
          icon={<Edit />}
        />
      )}

      {!noDelete && (
        <Button
          shape="circle"
          type="link"
          onClick={() => {
            usePlatformStore.getState().setOpenOnFreeTrialMessageModel(true);
          }}
          disabled={isConfigurator ? false : record.status === 'accepted'}
          style={{marginRight: '20px', backgroundColor: '#F5FBF3'}}
          icon={<Delete />}
        />
      )}
    </Flex>
  ) : (
    <Flex align="center" justify="flex-start" style={{width: 'fit-content'}}>
      {!noEdit && (
        <Button
          onClick={() => {
            setShowModel(true);
            setEditData(record);
            setIsEdit(true);
          }}
          shape="circle"
          type="link"
          disabled={isConfigurator ? false : record.status === 'accepted'}
          style={{marginRight: '20px', backgroundColor: '#F5FBF3'}}
          icon={<Edit />}
        />
      )}

      {!noDelete && (
        <Popconfirm
          title="Sure to delete?"
          onConfirm={() => {
            if (handleDelete) {
              handleDelete([record._id]);
            }
          }}
        >
          <Button
            shape="circle"
            type="link"
            disabled={isConfigurator ? false : record.status === 'accepted'}
            style={{marginRight: '20px', backgroundColor: '#F5FBF3'}}
            icon={<Delete />}
          />
        </Popconfirm>
      )}
    </Flex>
  );
};

export default ActionsButton;
